// System API Keys for Pro Users
// These keys are provided by the system for Pro/Premium users
// IMPORTANT: In production, these should be stored securely on the backend

export interface SystemApiKeys {
  openai: string;
  anthropic: string;
  googleAI: string;
}

// System-provided API keys for Pro users
// In development, these come from environment variables
// In production, these should be handled by backend API proxy
export const SYSTEM_API_KEYS: SystemApiKeys = {
  openai: process.env.REACT_APP_OPENAI_API_KEY || 'SYSTEM_PROVIDED',
  anthropic: process.env.REACT_APP_ANTHROPIC_API_KEY || 'SYSTEM_PROVIDED',
  googleAI: process.env.REACT_APP_GOOGLE_AI_API_KEY || 'SYSTEM_PROVIDED'
};

// Check if user should use system keys
export const shouldUseSystemKeys = (subscriptionTier?: string): boolean => {
  return subscriptionTier === 'pro' || subscriptionTier === 'premium' || subscriptionTier === 'enterprise';
};

// Get appropriate API key based on user's subscription
export const getApiKeyForUser = (
  modelType: 'openai' | 'anthropic' | 'googleAI',
  subscriptionTier?: string,
  userProvidedKey?: string
): string | null => {
  // Pro users get system keys
  if (shouldUseSystemKeys(subscriptionTier)) {
    return SYSTEM_API_KEYS[modelType];
  }
  
  // Free users must provide their own keys
  return userProvidedKey || null;
};